import baseFillers from "../data/fillers.json";
import baseSynonyms from "../data/synonyms.json";

const extraSynonyms = {
  "beispiel": ["fall", "illustration", "beleg"],
  "frage": ["thema", "punkt", "problemstellung"],
  "antwort": ["reaktion", "rückmeldung", "erklärung"],
  "ergebnis": ["resultat", "ausgang", "schluss"],
  "grund": ["ursache", "hintergrund", "anlass"],
  "wahr": ["zutreffend", "richtig", "stimmig"],
  "falsch": ["unzutreffend", "nicht korrekt", "nicht ganz richtig"],
  "leicht": ["einfach", "locker", "gut machbar"],
  "schwierig": ["anspruchsvoll", "kompliziert", "herausfordernd"],
  "helfen": ["unterstützen", "beistehen", "weiterhelfen"],
  "nutzen": ["verwenden", "einsetzen", "gebrauchen"],
  "bauen": ["konstruieren", "aufbauen", "zusammenbauen"],
  "finden": ["entdecken", "ermitteln", "ausfindig machen"],
  "geben": ["liefern", "bereitstellen", "übergeben"],
  "nehmen": ["mitnehmen", "aufgreifen", "annehmen"],
  "brauchen": ["benötigen", "nötig haben", "verwenden können"],
  "wollen": ["möchten", "anstreben", "im sinn haben"],
  "können": ["in der lage sein", "schaffen", "hinbekommen"],
  "wissen": ["kennen", "nachvollziehen", "im blick haben"],
  "verstehen": ["nachvollziehen", "begreifen", "einordnen"],
  "wichtigsten": ["zentralsten", "entscheidendsten", "relevantesten"]
};

const sentenceStartFillers = [
  ...baseFillers,
  "naja",
  "ganz ehrlich",
  "wenn ich ehrlich bin",
  "ich mein"
];

const middleFillers = [
  "halt",
  "irgendwie",
  "ehrlich gesagt",
  "meiner meinung nach",
  "im endeffekt",
  "wie gesagt",
  "gefühlt"
];

const sentenceEndFillers = [
  "oder so",
  "glaube ich",
  "wenn man ehrlich ist",
  "würde ich sagen",
  "denke ich zumindest"
];

export function getHumanizationDatabase() {
  return {
    fillers: {
      sentenceStart: sentenceStartFillers,
      middle: middleFillers,
      sentenceEnd: sentenceEndFillers
    },
    synonyms: {
      ...baseSynonyms,
      ...extraSynonyms
    }
  };
}
